import { ENDPOINTS } from "@/api/application-api";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast } from "@/utils/toast";
import { useMutation } from "@tanstack/react-query";

export const useSetOrRemoveVertexAIKeys = (userToken: string) =>
  useMutation(
    (body: {
      vertexai_project: string;
      vertexai_location: string;
      vertexai_security_credentials: string;
      workspace_id: number;
    }) =>
      fetch(ENDPOINTS.set_or_remove_vertexai_keys, {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify(body),
      }),
    {
      onSuccess: async (response) => {
        const data = await response.json();
        if (!response.ok) {
          if ("message" in data) {
            if (typeof data.message === "object") {
              displayErrorToast(data.message.at(0).msg || "An error occurred");
            } else {
              displayErrorToast(data.message || "An error occurred");
            }
          }
        }
        return data;
      },
      onError: (error) => {
        displayErrorToast(error);
      },
    },
  );
